export function getDirectParent(trigger) {
    return trigger.parentElement;
}
export function getClosestCardHeader(trigger) {
    return trigger.closest('.ant-card-head');
}
export function getClosestCardBody(trigger) {
    return trigger.closest('.ant-card-body');
}
export function getClosestTableBody(trigger) {
    return trigger.closest('.ant-table-tbody');
}
export function getClosestTableRow(trigger) {
    return trigger.closest('tr');
}
export function getClosestTableCell(trigger) {
    return trigger.closest('td');
}
export function getClosestSelectionTable(trigger) {
    return trigger.closest('.selection-table');
}
export function getClosestButton(trigger) {
    return trigger.closest('button');
}
export function getClosestPopup(trigger) {
    return trigger.closest('#ant-popover');
}
export function getClosestRow(trigger) {
    return trigger.closest('.ant-row');
}
export function getClosestViewArea(trigger) {
    return trigger.closest('.view-area');
}
export function getDocumentBody() {
    return document.body;
}
